module.exports = __webpack_public_path__ + "static/img/ptfw_afsbcg_two.edbe1c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ptfw_afsbcg_two.png
// module id = YuOP
// module chunks = 21